import { plainToClass } from 'class-transformer';
import { IOrderAction } from './i-order-action';
import { OrderActions } from './order-actions.enum';
import { OrderState } from './order-state';
import { PersistedOrder } from './persisted-order';

const initialState: OrderState = {
  syncing: false,
  list: {},
  formValues: undefined,
};

export function orderReducer(
  state: OrderState = initialState,
  action: IOrderAction,
): OrderState {
  const newState = { ...state } || { ...initialState };
  switch (action.type) {
    case OrderActions.UPDATE_ORDER_PROGRESS_SUCCESS: {
      const { order } = action;
      const updatedOrder = plainToClass(PersistedOrder, {
        ...newState.list[order.orderId],
        ...order,
      });

      return {
        ...newState,
        list: {
          ...newState.list,
          [order.orderId]: updatedOrder,
        },
      };
    }
    case OrderActions.CREATE_REQUEST:
    case OrderActions.UPDATE_LIST_REQUEST:
    case OrderActions.UPDATE_REQUEST:
      return { ...state, syncing: true };
    case OrderActions.FORM_CHANGE:
      return { ...state, formValues: action.formValues };
    case OrderActions.UPDATE_LIST_SUCCESS: {
      const newList = { ...state.list };
      const { orders } = action;
      orders.forEach((o) => { newList[o.orderId] = o; });

      return {
        ...state,
        list: newList,
      };
    }
    case OrderActions.CREATE_SUCCESS: {
      const { order } = action;

      return {
        ...state,
        syncing: false,
        list: { ...state.list, [order.orderId]: order },
      };
    }
    case OrderActions.UPDATE_SUCCESS: {
      const { order } = action;

      return {
        ...state,
        syncing: false,
        list: { ...state.list, [order.orderId]: order },
      };
    }
    case OrderActions.UPDATE_LIST_ERROR:
    case OrderActions.CREATE_ERROR:
    case OrderActions.UPDATE_ERROR:
      return {
        ...state,
        syncing: false,
      };
    default:
      return state;
  }
}
